export class ClienteAnaliseMercadoClassificacaoSearchLancamentoOptions {
    canCreateLancamento: boolean;
    canOpenLancamento: boolean;
    canDeleteLancamento: boolean;

    /** Verifica se possui alguma opção habilitada */
    hasAnyOption(): boolean {
        return this.canCreateLancamento ||
                this.canOpenLancamento ||
                this.canDeleteLancamento;
    }
}
